import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import React from "react";
import { useFormContext } from "react-hook-form";
import type { DealCompanySetting } from "~/models/CompanySetting";
import { convertToComboBoxOption } from "~/models/CompanySetting";
import type { DealSearchCondition } from "~/models/Deal";

type Props = {
	handleChangeMaintenanceCompanyInput: (inputText: string) => void;
	maintenanceCompanies: DealCompanySetting[] | null;
	onChangeCompanyMasterId: (companyMasterId: number | undefined) => void;
	selectedCompanyMasterId: number | undefined;
};

export function MaintenanceCompanyCombobox({
	handleChangeMaintenanceCompanyInput,
	selectedCompanyMasterId,
	maintenanceCompanies,
	onChangeCompanyMasterId
}: Props) {
	const { setValue } = useFormContext<DealSearchCondition>();
	const selectedMaintenanceCompany = maintenanceCompanies?.find(
		({ companyMasterId }) => companyMasterId === selectedCompanyMasterId
	);

	const onChangeValue: Required<
		ComponentProps<typeof SingleComboBox>
	>["onChange"] = React.useCallback(
		(value) => {
			const companyMasterId = value ? Number(value.value) : undefined;
			setValue("companyMasterId", companyMasterId);
			onChangeCompanyMasterId(companyMasterId);
		},
		[onChangeCompanyMasterId, setValue]
	);

	return (
		<SingleComboBox
			defaultValue={
				selectedMaintenanceCompany
					? convertToComboBoxOption(selectedMaintenanceCompany)
					: null
			}
			onChange={onChangeValue}
			onInputChange={handleChangeMaintenanceCompanyInput}
			options={
				maintenanceCompanies?.map((cs: DealCompanySetting) =>
					convertToComboBoxOption(cs)
				) ?? []
			}
			placeholder="管理会社"
		/>
	);
}
